import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import AssignmentPreview from '../../assignment_preview';

const AssignmentPreviewFormik = ({ remove, form, name, subText }) => {
  const peopleIds = _.get(form, `values.${name}`, []);

  const onRemove = personId => {
    const indexToRemove = _.findIndex(peopleIds, person => _.isEqual(person, personId));
    remove(indexToRemove);
  };

  return <AssignmentPreview peopleIds={peopleIds} onRemove={onRemove} subText={subText} />;
};

AssignmentPreviewFormik.propTypes = {
  form: PropTypes.shape({ values: PropTypes.shape({}) }),
  name: PropTypes.string,
  remove: PropTypes.func.isRequired,
  subText: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default AssignmentPreviewFormik;
